import { render, staticRenderFns } from "./base-message.vue?vue&type=template&id=5e27f7e0&scoped=true"
import script from "./base-message.vue?vue&type=script&lang=js"
export * from "./base-message.vue?vue&type=script&lang=js"
import style0 from "./base-message.vue?vue&type=style&index=0&id=5e27f7e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e27f7e0",
  null
  
)

export default component.exports